"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.ProductPropertiesEnum = exports.ProductSummaryEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["ProductSummaryEvent"] = "ProductSummaryEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ProductSummaryEventActions;
(function (ProductSummaryEventActions) {
    ProductSummaryEventActions["ProductSummaryCreated"] = "ProductSummaryCreated";
    ProductSummaryEventActions["ProductSummaryUpdated"] = "ProductSummaryUpdated";
    ProductSummaryEventActions["ProductSummaryDeleted"] = "ProductSummaryDeleted";
    ProductSummaryEventActions["CreateProductSummary"] = "CreateProductSummary";
    ProductSummaryEventActions["UpdateProductSummary"] = "UpdateProductSummary";
    ProductSummaryEventActions["DeleteProductSummary"] = "DeleteProductSummary";
})(ProductSummaryEventActions = exports.ProductSummaryEventActions || (exports.ProductSummaryEventActions = {}));
var ProductPropertiesEnum;
(function (ProductPropertiesEnum) {
    ProductPropertiesEnum[ProductPropertiesEnum["contract"] = 0] = "contract";
    ProductPropertiesEnum[ProductPropertiesEnum["direct"] = 1] = "direct";
    ProductPropertiesEnum[ProductPropertiesEnum["locallySourced"] = 2] = "locallySourced";
    ProductPropertiesEnum[ProductPropertiesEnum["ces"] = 3] = "ces";
    ProductPropertiesEnum[ProductPropertiesEnum["specialOrder"] = 4] = "specialOrder";
    ProductPropertiesEnum[ProductPropertiesEnum["scoop"] = 5] = "scoop";
    ProductPropertiesEnum[ProductPropertiesEnum["dwo"] = 6] = "dwo";
    ProductPropertiesEnum[ProductPropertiesEnum["discontinued"] = 7] = "discontinued";
    ProductPropertiesEnum[ProductPropertiesEnum["recentlyPurchased"] = 8] = "recentlyPurchased";
    ProductPropertiesEnum[ProductPropertiesEnum["jit"] = 9] = "jit";
    ProductPropertiesEnum[ProductPropertiesEnum["supplierOutOfStock"] = 10] = "supplierOutOfStock";
    ProductPropertiesEnum[ProductPropertiesEnum["onOrderGuide"] = 11] = "onOrderGuide";
    ProductPropertiesEnum[ProductPropertiesEnum["specialVendor"] = 12] = "specialVendor";
    ProductPropertiesEnum[ProductPropertiesEnum["onShoppingList"] = 13] = "onShoppingList";
    ProductPropertiesEnum[ProductPropertiesEnum["onOrderGuideOrOnShoppingList"] = 14] = "onOrderGuideOrOnShoppingList";
    ProductPropertiesEnum[ProductPropertiesEnum["outOfStock"] = 15] = "outOfStock";
    ProductPropertiesEnum[ProductPropertiesEnum["available"] = 16] = "available";
    ProductPropertiesEnum[ProductPropertiesEnum["onMasterList"] = 17] = "onMasterList";
    ProductPropertiesEnum[ProductPropertiesEnum["customerPill"] = 18] = "customerPill";
    ProductPropertiesEnum[ProductPropertiesEnum["availableToPromise"] = 19] = "availableToPromise";
    ProductPropertiesEnum[ProductPropertiesEnum["mslRestricted"] = 20] = "mslRestricted";
    ProductPropertiesEnum[ProductPropertiesEnum["proprietary"] = 21] = "proprietary";
})(ProductPropertiesEnum = exports.ProductPropertiesEnum || (exports.ProductPropertiesEnum = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyProductSummaries"] = "MyProductSummaries";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
